function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { i18n } from 'invision-core';
import CustomerCareLocaleKeys from '../../../../../locales/keys';
import { clearRemarkBeingEdited, createCustomerRemark, setRemarkBeingEdited, updateCustomerRemark } from '../../../../../reducers/actions/customer.remarks.actions';
import { IsCreatingRemarkSelector, IsUpdatingRemarkSelector, RemarksLastAttemptErrorSelector, RemarkToEditSelector } from '../../../../../reducers/selectors/customer.remarks.selectors';
import { NOTIFICATION_TIME_LENGTH } from '../../../../../customercare.constants';
import moment from 'moment';
var MAX_BODY_LENGTH = 8000;
var REMARK_PRIORITY = {
  LOW: 3,
  MEDIUM: 2,
  HIGH: 1
};
var CreateRemarkPopupCtrl = /*#__PURE__*/function () {
  function CreateRemarkPopupCtrl($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, CreateRemarkPopupCtrl);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      uiNotificationService: uiNotificationService,
      MAX_BODY_LENGTH: MAX_BODY_LENGTH,
      popupApi: null,
      REMARK_PRIORITY: REMARK_PRIORITY
    });
  }
  return _createClass(CreateRemarkPopupCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.resetForm();
      this.showForm = false;
      this.minExpirationDate = new Date();
      this.remarkCreationCallback = this.onRemarkCreation() || function () {};
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          remarkCreationLastAttemptError: RemarksLastAttemptErrorSelector(store),
          isCreatingRemark: IsCreatingRemarkSelector(store),
          isUpdatingRemark: IsUpdatingRemarkSelector(store),
          remark: RemarkToEditSelector(store)
        };
      };
      var controllerActions = {
        createCustomerRemark: createCustomerRemark,
        updateCustomerRemark: updateCustomerRemark,
        setRemarkBeingEdited: setRemarkBeingEdited,
        clearRemarkBeingEdited: clearRemarkBeingEdited
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.CustomerCareLocaleKeys = CustomerCareLocaleKeys;

      // hook the popupApi
      var onRegisterApi = this.config.onRegisterApi;
      this.config.onRegisterApi = function (_ref) {
        var api = _ref.api;
        _this.popupApi = Object.assign({}, api, {
          open: function open() {
            _this.resetForm();
            _this.showForm = true;
            // NOTE: must wait for the ng-if bound to showForm to operate, for the popup centering logic
            _this.$timeout(function () {
              api.open();
            });
          }
        });
        onRegisterApi && onRegisterApi({
          api: _this.popupApi
        });
      };
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
      this.closePopup();
      this.actions.clearRemarkBeingEdited();
    }
  }, {
    key: "updateRemark",
    value: function updateRemark() {
      this.actions.setRemarkBeingEdited(this.state.remark);
    }
  }, {
    key: "handleClickCreateRemarkButton",
    value: function handleClickCreateRemarkButton() {
      var _this2 = this;
      if (this.createRemarkForm.$valid) {
        var request = Object.assign({}, {
          remark: this.state.remark,
          customerId: this.customerId
        });
        var promise;
        if (this.isEditingRemark) {
          promise = this.actions.updateCustomerRemark(request).then(function () {
            _this2.uiNotificationService.success(i18n.translate(CustomerCareLocaleKeys.CREATE_REMARK.UPDATE_SUCCESS), null, {
              timeOut: NOTIFICATION_TIME_LENGTH
            });
          });
        } else {
          promise = this.actions.createCustomerRemark(request).then(function () {
            _this2.uiNotificationService.success(i18n.translate(CustomerCareLocaleKeys.CREATE_REMARK.SUCCESS), null, {
              timeOut: NOTIFICATION_TIME_LENGTH
            });
          });
        }
        promise.then(function () {
          _this2.remarkCreationCallback();
          _this2.closePopup();
        });
      }
    }
  }, {
    key: "closePopup",
    value: function closePopup() {
      this.popupApi.close();
      this.actions.clearRemarkBeingEdited();
      this.showForm = false;
    }
  }, {
    key: "onExpirationDateChanged",
    value: function onExpirationDateChanged() {
      var expirationDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
      this.state.remark.Expiration = moment(expirationDate).endOf('day').toDate();
      this.updateRemark();
    }
  }, {
    key: "resetForm",
    value: function resetForm() {
      // called before $ngRedux.connect, must guard
      this.actions && !this.state.remark && this.actions.setRemarkBeingEdited({
        Priority: 3
      });
      if (this.createRemarkForm) {
        this.createRemarkForm.$setUntouched(true);
        this.createRemarkForm.$setPristine(true);
      }
    }
  }, {
    key: "titleKey",
    get: function get() {
      return this.isEditingRemark ? CustomerCareLocaleKeys.CREATE_REMARK.EDIT_REMARK : CustomerCareLocaleKeys.CREATE_REMARK.NEW_REMARK;
    }
  }, {
    key: "isEditingRemark",
    get: function get() {
      return this.state.remark && this.state.remark.Id;
    }
  }]);
}();
export default {
  template: require('./create.remark.popup.html'),
  bindings: {
    config: '<',
    onRemarkCreation: '&',
    customerId: '@'
  },
  controllerAs: 'CreateRemarkPopup',
  controller: CreateRemarkPopupCtrl
};